import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input, Container } from "reactstrap";
import SelectBoxSearch from "../../common/SelectBoxSearch";
import SelectBoxSearchAssetItem from "../../common/SelectBoxSearchAssetItem";
import useFormValidation from "../../common/useFormValidation";
import { TimePicker } from "react-time-picker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "../../../style/employee.css";
import api from "../../../apis/api";
import Notifications from "../../../components/common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
const FormAddEditLeaves = React.memo((props) => {
  const {
    selectedItem,
    selectedAsset,
    userList,
    handleAddAsset,
    handleUpdateAsset,
    assetItemList,
    handlerecholidayCalendarArray,
    dateArray,
    myleavelist,
    dutytypeArray,
    employeedetails
  } = props;
  var loginUser = JSON.parse(localStorage.getItem("user"));

  const [options,setOptions ]=useState([]);
  const [curRadiobutton,setcurRadiobutton] =useState(0);
  const [datediff,setdatediff]=useState(0);
  const [dutytype,setdutytype]=useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [isViewtodate,setisViewtodate]=useState(false);
  const [isViewtime,setisViewtime]=useState(false);
  const [itemModel, setItemModel] = useState("");
  const [itemUniqueId, setItemUniqueId] = useState("");
  const [FromTime, setFromTime] = useState(new Date().toLocaleTimeString('en-GB'));
  const [ToTime, setToTime] = useState(new Date().toLocaleTimeString('en-GB'));
  const [reason, setReason] = useState("");
  const [handoverto, sethandover] = useState("");
  const [contact, setcontact] = useState("");
  const [dutyId, setDutyId] = useState("");
   const [error, setError] = useState(null);
     const [error1, setError1] = useState(null);
     const [employeelist,setemployeelist]=useState([]);
   const [isFormValidh,setisFormValidh] =useState(false);
     const [contactdetails,setcontactdetails]=useState("");
  // for item inside asset.
  const [
    formValidationStateAssetItem,
    setFormValidationStateAssetItem,
  ] = useState({});
  const callValidationAssetItem = useRef(false);
  const [loaded, setLoaded] = useState(false);
   
  const DarkBackground = styled.div`
  display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 999; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
  `;
  const { formValidation, isFormValid } = useFormValidation(
    formValidationStateAssetItem
  ); // for item inside asset.
  useEffect(() => {
    // calls when asset item's add&edit form is submited.
    setisFormValidh(isFormValid);
    callValidationAssetItem.current && callBackAfterValidationAssetItem();
   
  }, [formValidation,isFormValid,setisFormValidh]);
  let holidaylist=[];
  if(handlerecholidayCalendarArray.length >0)
   {    
    handlerecholidayCalendarArray[0].map(function (hol){
    holidaylist.push(new Date(hol.holidayDate));
  });
   }
  let allholiday=[];
  if(handlerecholidayCalendarArray.length >0)
   {  
  handlerecholidayCalendarArray[0].map(function (hol){
    allholiday.push(moment(hol.holidayDate).format("YYYY-MM-DD"));
});
   }
const validateMobileNumber = (number) => {
  const regex = /^[6-9]\d{9}$/; // Indian mobile number validation (10 digits starting with 6, 7, 8, or 9)
  return regex.test(number);
};
const handleChange = (e) => {
  const value = e;
  setcontactdetails(value);

  if (!validateMobileNumber(value) && value !== "") {
    setError1("Invalid mobile number. Please enter a valid 10-digit number.");
  } else {
    setError1("");
  }
};
  useEffect(()=>{
    //console.log("assetItemList",assetItemList)
    let empArr1 = [];
       const fetchApi = async () => {
         const response = await api.empSkill().GetAllEmployeeList();
           response.data
             .forEach((element) => {
               empArr1.push({ value: element, label: element.employeeName,empId:element.employeeId });
             });
             setemployeelist(empArr1);
           }
           fetchApi();
    if(assetItemList!=null){
      let empArr = [];
      //only show software Type Assets in Asset Options
      assetItemList.filter(n=>n.itemType == 1).forEach((element) => {
        empArr.push({ value: element, label: element.itemName,itemId:element.itemId });
      });  
      setOptions(empArr);
    }
    if(employeedetails.length >0)
    {
      setcontactdetails(employeedetails[0].mobileNumber);
    }
    
  },[assetItemList,setemployeelist,setcontactdetails,employeedetails]);
  const handlecalcel =React.useCallback(
    (e) => {
      e.preventDefault();
     
    });
const formValidationOnSubmit = React.useCallback(
    (e) => {
      const phoneRegex = /^[0-9]{10}$/;
      e.preventDefault();
      let formValidationList = {
        // key name should be same as the input field name to represtent in form.
        dutytype: {
          required: true,
          isValid: true,
          value: dutytype,
          errorMessage: "",
        },
        fromDate: {
          required: true,
          isValid: true,
          value: fromDate,
          errorMessage: "",
        },
        toDate: {
          required: true,
          isValid: true,
          value: toDate,
          errorMessage: "",
        },
        reason: {
          required: true,
          isValid: true,
          value: reason,
          errorMessage: "",
        },
       contact: {
          required: true,
          isValid: phoneRegex.test(contactdetails),
          value: contactdetails,
          errorMessage:  phoneRegex.test(contactdetails) ? "" : "Enter a valid 10-digit phone number",
        },
      };
      setFormValidationStateAssetItem(formValidationList); //this set call the custom hook useFormValidation.
      callValidationAssetItem.current = true;
    },
    [dutytype, fromDate,toDate,reason,contactdetails]
  );
 
  // function
  const callBackAfterValidationAssetItem = React.useCallback(() => {
    try{
      const phoneRegex = /^[0-9]{10}$/; 
      const isFormValid =
      dutytype.trim() !== "" &&
      reason.trim() !== "" &&
      contactdetails.trim() !== "" &&
      phoneRegex.test(contactdetails); // Contact should be a valid 10-digit number

      if (isFormValid == true) {
        if(datediff > 0)
          {
        setLoaded(true);
      let formData = {};
      formData = {
        dutyTypeId:parseInt(dutytype),
        employeeId:parseInt(loginUser.EmployeeId),
        fromDate:moment(fromDate).format("YYYY-MM-DD"),
        toDate:toDate == '' ? moment(fromDate).format("YYYY-MM-DD") : moment(toDate).format("YYYY-MM-DD"), 
        fromTime:curRadiobutton ==1 ? FromTime : "09:30",
        toTime:curRadiobutton ==1 ? ToTime : "18:30",
        noOfDays:curRadiobutton == 1 ? .5 : (curRadiobutton == 2 ? 1 : (datediff)) ,
        reason:reason,
        handOverTo:handoverto,
        contactDetails:contactdetails,
        dutyStatusId:"1"
       };
       var getDaysArray = getDatesInRange(fromDate, toDate);
       let hollist=[];
       myleavelist != "undefined" ? (myleavelist.map(function (day){
        var getfromtoDaysArray = getDatesInRange(moment(day.fromDate).format("YYYY-MM-DD"),moment(day.toDate).format("YYYY-MM-DD"));
        getfromtoDaysArray.map(function (s){
          var outlist=getDaysArray.some(item =>moment(item).format("YYYY-MM-DD") === s);
          var stringout=outlist.toString();
          if(stringout != 'false')
          {
            hollist.push("true");
          } 
          else
          {
           
          }
        })
        
      
      })) : hollist.push([]);
// if(hollist.length==0)
// {
  const fetchApi = async () => {
  const res=await api.dbduty().AddEditDutyApply(formData);
  if(res.status == 200)
  {
    setError({ ...error, message: "Duty Applied Successfully.", status: 200 });
      setTimeout(() => { 
    setLoaded(false);
    if (isFormValid == true) {
    window.location.reload();
    }
}, 9000);
  }
  else
  {
    setError({ ...error, message: res.data, status: 500 });
      setTimeout(() => { 
    setLoaded(false);
}, 3000);
  }
}
fetchApi();
// }
//   else

//   {
//     setError({ ...error, message: "Leave already applied on this days.", status: 500 });
//     // alert("Leave already applied on this days");
//   }

}
else
{
  setError({ ...error, message: "Days must be greater than 0" , status: 500 });
  setTimeout(() => { 
    setLoaded(false);
  
}, 3000);
}
    }
    }
    catch(e)
    {

    }
    
   },[fromDate,toDate,reason,handoverto,contactdetails]

  );
  // asset item valdation's and ADD&EDIT call.
  const date_diff_indays = function (date1, date2,holidaylist) {
    const dt1 = new Date(date1);
  const dt2 = new Date(date2);
  let count = 0;

  for (
    let dt = new Date(dt1);
    dt <= dt2;
    dt.setDate(dt.getDate() + 1) // Move to the next day
  ) {
    const isWeekend = dt.getDay() === 0 || dt.getDay() === 6; // Sunday = 0, Saturday = 6
    const isHoliday = holidaylist.some(
      (holiday) => new Date(holiday).toDateString() === dt.toDateString()
    );

    if (!isWeekend && !isHoliday) {
      count++;
    }
  }

  return count;
  };

  
  function getDatesInRange(startDate, endDate) {
    const date =new Date(startDate);
  const enddate=new Date(endDate)
    const dates = [];
  
    while (date <= enddate) {
      dates.push(moment(new Date(date)).format("YYYY-MM-DD"));
      date.setDate(date.getDate() + 1);
    }
  
    return dates;
  }
  const setTodatechanes=React.useCallback((todate) =>{
    settoDate(todate);
    todate=todate;
    const newdatediff=date_diff_indays(fromDate,todate,holidaylist);
 
     var getDaysArray = getDatesInRange(fromDate, todate)
    let count=0;
    let hollist=[];
    getDaysArray != "undefined" ? (getDaysArray.map(function (day){
      // var day = getDayName(day, "en-IN");
      var outlist=holidaylist.some(item =>moment(item).format("YYYY-MM-DD") === day);
      var stringout=outlist.toString();
      if(stringout != 'false')
      {
        hollist.push("true");
      } 
      else
      {
       
      }
    
    })) : hollist.push([]);
    if(fromDate != '')
      {
        if(todate  >= fromDate)
          {
            if(newdatediff<=0)
              {
                setError({ ...error, message: "To Date must be greater than From Date.", status: 500 });
                setdatediff(0);
              }
           else 
           {
            setdatediff(newdatediff);
            
           }
          
          }
          else
          {
            setError({ ...error, message: "To Date must be greater than From Date.", status: 500 });
            // alert("Select duty type.");
            setFromDate(new Date());
            settoDate(new Date());
            setdatediff(0);
          }
          }
          else{
            // setError({ ...error, message: "ToDate must be greater than FromDate.", status: 500 });
            setdatediff(0);
          }
    

  },[fromDate,datediff])
  // const setTodatechanes=React.useCallback((todate) =>{
  //   settoDate(todate.target.value);
  //   const newdatediff=date_diff_indays(fromDate,todate.target.value);
  //   setdatediff(date_diff_indays(fromDate,todate.target.value));
  //   if(newdatediff === 0)
  //   {
  //     alert("'To' Date must be greater than 'From' Date");
  //     settoDate("");
  //   }
  // },[fromDate,datediff])
  const setFromdatechanes=React.useCallback((fromdate) =>{
    setFromDate(fromdate);
    const dd=curRadiobutton;
    if(curRadiobutton == 3)
    {
      if(toDate != '')
        {
          if(toDate  >= fromdate)
            {
              const newdatediff=date_diff_indays(fromdate,toDate,holidaylist);
              var getDaysArray = getDatesInRange(fromdate,toDate)
              let count=0;
              let hollist=[];
              getDaysArray != "undefined" ? (getDaysArray.map(function (day){
                // var day = getDayName(day, "en-IN");
                var outlist=holidaylist.some(item =>moment(item).format("YYYY-MM-DD") === day);
                var stringout=outlist.toString();
                if(stringout != 'false')
                {
                  hollist.push("true");
                } 
                else
                {
                  if(newdatediff<=0)
                    {
                      setError({ ...error, message: "To Date must be greater than From Date.", status: 500 });
                     setdatediff(0);
                    }
                 else if(newdatediff >=5 && hollist.length >0)
                 {
                  setdatediff(newdatediff);
                  
                 }
                 else if(newdatediff<5 && hollist.length ==0)
                 {
                  setdatediff(newdatediff);
                 }
                 else if(newdatediff<5 && hollist.length >0)
                 {
                  setdatediff(newdatediff-hollist.length);
                 }
                 
                 else
                 {
                  setdatediff(newdatediff-hollist.length);
                 }
                }
              
              })) : hollist.push([]);
              if(dutytype == "")
              {
                setError({ ...error, message: "Select duty type.", status: 500 });
                // alert("Select duty type.");
                setFromDate("");
              }
              else
              {
                
              }
            }
            else
            {
              setError({ ...error, message: "To Date must be greater than From Date.", status: 500 });
              // alert("Select duty type.");
              setFromDate(new Date());
              settoDate(new Date());
              setdatediff(0);
            }
        }
        else{
          // setError({ ...error, message: "ToDate must be greater than FromDate.", status: 500 });
          setdatediff(0);
        }
    }
    else
    {
      if(curRadiobutton ==1)
      {
        setdatediff(.5);
      }
      else
      {
        setdatediff(1);
      }
    }
    
    
  },[fromDate,toDate,dutytype,curRadiobutton])
  const handleonchangeduetytype =React.useCallback((type) =>{
    setdutytype(type);
  })
  const toggleradiobutton =React.useCallback((e) =>{
    setcurRadiobutton(e);
    if(e==1)
    {
      setisViewtodate(false);
      setisViewtime(true);
      setdatediff(.5);
    }
    else if(e==2)
    {
      setisViewtodate(false);
      setisViewtime(false);
      setdatediff(1);
    }
    else
    {
      setisViewtodate(true);
      setisViewtime(false);
    }
    
  },[setdatediff,setisViewtodate,setisViewtime])
  const handleTime = React.useCallback(
    (e,time) =>{
if(time == 1)
{
  if(e !=null)
  {
    setFromTime(e);
  }
  else
  {
  setFromTime(new Date().toLocaleTimeString('en-GB'));
  }
}
else
{
    if(e !=null)
    {
    setToTime(e);
    }
    else
    {
      setToTime(new Date().toLocaleTimeString('en-GB'));
    }
}
    }
  )
  const formValidationOnSubmitAddDuty = React.useCallback(
    (e) => {
      e.preventDefault();
      let formValidationList = {
        // key name should be same as the input field name to represtent in form.
        itemModel: {
          required: true,
          isValid: true,
          value: itemModel,
          errorMessage: "",
        },
        itemUniqueId: {
          required: true,
          isValid: true,
          value: itemUniqueId,
          errorMessage: "",
        },
      };
      setFormValidationStateAssetItem(formValidationList); //this set call the custom hook useFormValidation.
      callValidationAssetItem.current = true;
    },
    [itemModel, itemUniqueId]
  );

  // asset add after validation.
  // const callBackAfterValidationAssetItem = React.useCallback(() => {
  //   if (isFormValid) {
  //     // if form valid.
  //     handleFormSubmit();
  //   }
  // }, [isFormValid, handleFormSubmit]);

  return (
    <Container>
    <Form onSubmit={formValidationOnSubmit}>
  
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label for="exampleEmail">Duty Type</Label>
            {/* <Input
                type="select"
                name="select"
                onChange={(e) => handleonchangeduetytype(e.target.value)}
              >
                <option value="">select Type</option>
                <option value="1">Work From Home</option>
                <option value="2">Attendence Override</option>
               
              </Input> */}
              <Input type="select" name="leaveTypeId" className="form-control"  onChange={(e) => handleonchangeduetytype(e.target.value)} value={dutytype}>
                        <option value={0}>Select Type</option>
                        {dutytypeArray.map((duty, i) => (
                        <option
                        key={i}
                        value={duty.leaveTypeId}    
                        // selected={
                        //     data.rating == request.requestTypeId ? true : false
                        //   }                     
                        >
                        {duty.type}
                        </option>
                       ))}    
                    </Input> 
                    {Object.keys(formValidation).length !== 0 &&
              !formValidation.dutytype.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.dutytype.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        
      </Row>
      <Row form>
      <Col md={6}>
          <FormGroup>
            <Label for="examplePassword">Days</Label>
            <FormGroup check >
                <Label check className="radio-days">
                  <Input type="radio" onClick={() =>toggleradiobutton(1)}  name="radio1" /> {"< "}1.0
                </Label>
             
              
                <Label check className="radio-days">
                  <Input type="radio" onClick={() =>toggleradiobutton(2)} name="radio1" />= 1.0
                </Label>
              
              
                <Label check className="radio-days">
                  <Input type="radio" onClick={() =>toggleradiobutton(3)} name="radio1" /> {"> "}1.0
                </Label>
              </FormGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={6}>
          <FormGroup>
          {isViewtodate == true ? (<Label for="exampleEmail">From</Label>) : (<Label for="exampleEmail">On</Label>)}   
        <div className="form-group">
        <DatePicker
          style={{ width: "100%" }}
            
            selected={fromDate}
              excludeDates={holidaylist}
                minDate={new Date('2026-04-26')} // Set your start date
                maxDate={new Date('2026-09-30')} // Set your end date
              dateFormat="dd-MM-yyyy"
              // tileClassName={({ date, view }) => {
              //   if(holidaylist.find(x=>x===moment(date).format("DD-MM-YYYY"))){
              //    return  'highlight'
              //   }
              //   else if(dateArray.find(x=>x===moment(date).format("DD-MM-YYYY"))){
              //     return  'leavehighlight'
              //    }
              // }}

              // value={
              //   employeeDetails?.dateOFBirth?.substring(0, 10) ?? new Date()
              // }
          
              onChange={(e) =>
                setFromdatechanes(e)
              }
              // style={inputHeight}
            />
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.fromDate.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.fromDate.errorMessage}
                </span>
              )}
          </div>    
            {isViewtodate == true ? (<FormGroup><Label for="exampleEmail">To</Label>
            <DatePicker selected={toDate} excludeDates={holidaylist} dateFormat="dd-MM-yyyy" onChange={(e) => setTodatechanes(e)  }   minDate={new Date('2026-04-26')} // Set your start date
                        maxDate={new Date('2026-09-30')} // Set your end date
            />
             {Object.keys(formValidation).length !== 0 &&
              !formValidation.toDate.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.toDate.errorMessage}
                </span>
              )}
            </FormGroup>) : null}
             
          </FormGroup>
        </Col>
       <Col md={6}>
       <FormGroup>
     
        <br/>
        <Label>Days {curRadiobutton == 1 ? .5 : (curRadiobutton == 2 ? 1 : datediff === 0 ? 0 : datediff)}</Label>
        
       </FormGroup>
       </Col>
      </Row>
      {isViewtime && (
          <Row form>
            <Col md={3}>
              <FormGroup>
                <Label>Time From</Label>
                <TimePicker
                  onChange={(e) => handleTime(e, 1)}
                  value={moment(FromTime, "hhmm").format("HH:mm")}
                  format="HH:mm"
                  closeClock={false}
                  disableClock
                  locale="sv-sv"
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>Time To</Label>
                <TimePicker
                  onChange={(e) => handleTime(e, 2)}
                  value={moment(ToTime, "hhmm").format("HH:mm")}
                  format="HH:mm"
                  closeClock={false}
                  disableClock
                  locale="sv-sv"
                />
              </FormGroup>
            </Col>
          </Row>
        )}
      <Row form>
        <Col md={6}>
          
          <FormGroup>
            <Label for="examplePassword">Reason</Label>
            <Input
              type="text"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.reason.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.reason.errorMessage}
                </span>
              )}
          </FormGroup>
        
        </Col>
        
      </Row>
     
      <Row form>
        <Col md={6}>
          
          <FormGroup>
            <Label for="examplePassword">Contact Number</Label>
            <Input
                         type="text"
                         value={contactdetails}
                         name="contactdetails"
                         onChange={(e) => handleChange(e.target.value)}
                       />
                       {error1 && <small style={{ color: "red" }}>{error1}</small>}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.contact.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.contact.errorMessage}
                </span>
              )}
          </FormGroup>
        
        </Col>
        
      </Row>
      <Row>
        <Col className="text-center">
          <Button
            type="submit"
            color=""
            className="btn-admin-settings"
            // onClick={handleFormSubmit}
            onClick={formValidationOnSubmit}
          >
            {selectedAsset !== "" ? "Apply" : "Add"}
          </Button>
          &nbsp;
          <Button color="" className="btn-cancel" onClick={handlecalcel}>
            Cancel
          </Button>
        </Col>
      </Row>
     
    </Form>
    <Notifications notifications={error}></Notifications>
    <DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
    </Container>
  );
});

export default FormAddEditLeaves;
